$(".product_slider").slick({
  slidesToShow: 3,
  autoplay: false,
  dots: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        variableWidth: true,
        arrows: false,
      },
    },
  ],
});

// document.addEventListener("DOMContentLoaded", function () {
  // Select all sets of tabs with the class "main_tab_row"
  const tabSets = document.querySelectorAll(".main_tab_row");

  // Loop through each tab set
  tabSets.forEach(function (tabSet) {
    if (window.matchMedia("(min-width: 0px)").matches) {
      const customTab = tabSet.querySelector(".custom_tab");
      const tabTitles = customTab.querySelector(".tab_titles");

      const activeBar = document.createElement("div");
      activeBar.className = "active_bar";

      tabTitles.appendChild(activeBar);
    }

    const tabTitles = tabSet.querySelectorAll(".tab_title");
    const tabContents = tabSet.querySelectorAll(".tab_content");
    const activeBar = tabSet.querySelector(".active_bar");

    function setActiveTab(index) {
      // Remove 'active' class from all tab titles
      tabTitles.forEach(function (tabTitle) {
        tabTitle.classList.remove("active");
      });

      // Add 'active' class to the clicked tab title
      tabTitles[index].classList.add("active");

      // Hide all tab contents
      tabContents.forEach(function (content) {
        content.classList.remove("show");
      });

      // Show the tab content corresponding to the clicked item
      tabContents[index].classList.add("show");

      // Calculate the width and left position of the active bar
      const activeTabTitle = tabTitles[index];
      const tabWidth = activeTabTitle.offsetWidth;
      const tabLeft =
        activeTabTitle.getBoundingClientRect().left -
        tabTitles[0].parentElement.getBoundingClientRect().left;

      if (window.matchMedia("(min-width: 0)").matches) {
        // Set the width and left position of the active bar
        activeBar.style.width = tabWidth + "px";
        activeBar.style.left = tabLeft + "px";
      }
    }

    tabTitles.forEach(function (title, index) {
      title.addEventListener("click", function (e) {
        e.preventDefault();
        setActiveTab(index);
        $(".product_slider").slick("refresh");
      });
    });

    setActiveTab(0);
  });
// });

// initializeCustomTabSlick();

// $(window).resize(initializeCustomTabSlick);
